// FIREBASE
import firebase from 'keys/firebase'
import { firestore } from 'firebase'

// STORAGE
import 'firebase/firestore'

// INSTANCIA DE DB
const db: firestore.Firestore = firebase.firestore()

// REFERENCIA
const ref = db.collection('reservations')

// ENVIAR FORMULARIO
const saveReservationForm = (form: IReservationFields) => {
	const nDoc = ref.doc()
	const nId = nDoc.id
	const nForm = form
	nForm.id = nId

	return ref.doc(nId).set(nForm)
}

export { saveReservationForm }
